// #3392 (Announcer Live Desk redesign) -- every class number on the Live Desk
// is shown with a "CL" prefix ("CL 107"). One helper so no surface hand-rolls
// the prefix. An empty/missing number stays empty (callers filter(Boolean)),
// and a number that already carries the prefix is not doubled.
export function formatClassNumber(classNumber) {
  const n = classNumber == null ? "" : String(classNumber).trim();
  if (!n) return "";
  return /^CL\s/i.test(n) ? n : `CL ${n}`;
}
